<div *ngIf="!this.selectedGateway"
     style="position: absolute; top: 50%; transform: translate(0, -50%); display: flex; flex-direction: column; align-items: center; gap: 10px;">
  <label style="font-size: 24px;">{{ 'REGISTRY.DEVICE.TEXT.SELECT_GATEWAY' | translate }}</label>
</div>
<dx-data-grid (onRowClick)="onDeviceRowClick.emit($event)"
              *ngIf="!!this.selectedGateway"
              [selectedRowKeys]="selectedRowDevice"
              [columnAutoWidth]="true"
              [dataSource]="selectedGatewayDevices!"
              [disabled]="isGatewayDrawerOpen"
              [loadPanel]="{enabled: false}"
              [paging]="{enabled: false}"
              [showBorders]="true"
              [showRowLines]="false"
              [wordWrapEnabled]="true"
              height="100%"
              id="deviceDataGrid"
              keyExpr="id">

  <dxo-toolbar>
    <dxi-item location="before">
      <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.DEVICES' | translate }}</p>
    </dxi-item>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
    </dxi-item>
    <dxi-item location="before" [visible]="isGatewayPendingConfig && hasPendingDevices">
      <div *dxTemplate="let data of 'content'">
        <dx-button (onClick)="cancelAllDevicePendingConfig()" hint="{{'REGISTRY.DEVICE.BUTTONS.REVERT_ALL_DEVICES' | translate}}"
                   stylingMode="text">
          <i class="material-symbols-outlined">undo</i>
        </dx-button>
      </div>
    </dxi-item>
    <dxi-item location="before">
      <div *dxTemplate="let data of 'content'">
        <dx-button (onClick)="showNewDeviceForm.emit()" hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                   stylingMode="text">
          <i class="vr-ic_fluent_add_24_regular"></i>
        </dx-button>
      </div>
    </dxi-item>
  </dxo-toolbar>

  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
  </dxo-search-panel>
  <dxo-selection mode="single"></dxo-selection>

  <dxi-column caption="{{'REGISTRY.DEVICE.NAME' | translate}}" dataField="name"></dxi-column>
  <dxi-column [visible]="hasPendingDevices" [width]="130" caption="" cellTemplate="changeTypeTemplate" dataField="changeType" type="buttons"></dxi-column>
  <dxi-column caption="{{'REGISTRY.DEVICE.TYPE' | translate}}" dataField="type.label"></dxi-column>
  <dxi-column caption="{{'REGISTRY.DEVICE.ACQUISITION_FREQUENCY' | translate}}"
              cellTemplate="acquisitionCronTemplate"
              dataField="acquisitionCron"></dxi-column>
  <dxi-column [allowEditing]="false" [width]="100" [alignment]="'center'"
              caption="{{'REGISTRY.DEVICE.STATUS' | translate}}" cellTemplate="statusTemplate"
              dataField="alarmStatus"></dxi-column>
  <dxi-column caption="" cellTemplate="actionsTemplate" type="buttons"></dxi-column>

  <div *dxTemplate="let data of 'changeTypeTemplate'">
    <span *ngIf="data.data.changeType === ChangeTypeEnum.CREATED" class="changeTypeBadge changeTypeCreated">
      {{ 'REGISTRY.DEVICE.TEXT.CHANGE_TYPE_CREATED' | translate }}
    </span>
    <span *ngIf="data.data.changeType === ChangeTypeEnum.UPDATED" class="changeTypeBadge changeTypeUpdated">
      {{ 'REGISTRY.DEVICE.TEXT.CHANGE_TYPE_UPDATED' | translate }}
    </span>
    <span *ngIf="data.data.changeType === ChangeTypeEnum.DELETED" class="changeTypeBadge changeTypeDeleted">
      {{ 'REGISTRY.DEVICE.TEXT.CHANGE_TYPE_DELETED' | translate }}
    </span>
  </div>

  <div *dxTemplate="let data of 'acquisitionCronTemplate'">
    <div>{{ getAcquisitionCronLabel(data.data.acquisitionCron) }}</div>
  </div>

  <div *dxTemplate="let data of 'actionsTemplate'" style="display: flex; justify-content: center; gap: 10px">

    <!-- CANCEL CONFIG -->

    <i (click)="revertDevicePendingConfig($event, data.data);"
       *ngIf="isGatewayPendingConfig && (data.data.changeType === ChangeTypeEnum.CREATED || data.data.changeType === ChangeTypeEnum.UPDATED || data.data.changeType === ChangeTypeEnum.DELETED)"
       [matTooltip]="'REGISTRY.DEVICE.TOOLTIP.CANCEL_CONFIG' | translate"
       class="material-symbols-outlined custom-action-icon">undo</i>


    <i (click)="openDuplicateDevice($event, data.data);"
       [matTooltip]="'REGISTRY.DEVICE.TOOLTIP.DUPLICATE' | translate"
       class="dx-icon-copy custom-action-icon"></i>

  </div>

  <div *dxTemplate="let data of 'statusTemplate'" style="display: flex; justify-content: center">
    <div *ngIf="data.data.alarmStatus === DeviceAlarmStatusEnum.ONLINE" class="online-status"></div>
    <div *ngIf="data.data.alarmStatus === DeviceAlarmStatusEnum.OFFLINE" class="offline-status"></div>
    <div *ngIf="data.data.alarmStatus === DeviceAlarmStatusEnum.WARNING" class="warning-status"></div>
  </div>
</dx-data-grid>

<dx-popup
  [visible]="!!duplicatingDevice"
  (onHiding)="duplicatingDevice = undefined"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [height]="220"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.DEVICE.TEXT.DUPLICATE_DEVICE' | translate"
  [width]="660">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="duplicateDevice()"
      [disabled]="!duplicateDeviceName"
      [height]="40"
      [stylingMode]="'contained'"
      icon="copy"
      text="{{'REGISTRY.DEVICE.BUTTONS.DUPLICATE' | translate}}"
      type="default">
    </dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="duplicatingDevice = undefined"
      [height]="40"
      [stylingMode]="'outlined'"
      icon="close"
      text="{{'BUTTONS.CANCEL' | translate}}">
    </dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <dx-text-box
      [(value)]="duplicateDeviceName"
      [maxLength]="gmService.STR_DIM_MID"
      [label]="'REGISTRY.DEVICE.TEXT.DUPLICATE_DEVICE_NAME_LABEL' | translate"
      style="width: 100%;">
    </dx-text-box>
  </div>
</dx-popup>
